import { Component, OnInit } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addhqmaster',
  template: require('./addhqmaster.component.html'),
  styles: [require('./addhqmaster.component.css')],
})
export class AddHQMasterComponent implements OnInit {

  model: NgbDateStruct;

  constructor(
  ) { }

  ngOnInit() {
    // this.gridHeight();
  }

  /* gridHeight() {
    // var height = 0;
    let windowHeight = window.innerHeight;
    let mainContentHeight = document.querySelector(".main_content").clientHeight;
    let mainContentHeaderHeight = document.querySelector(".main_content_header").clientHeight;
    document.getElementById('gridHeight').style.height = `${mainContentHeight - mainContentHeaderHeight - 60}px`;
    console.log('Window', windowHeight, 'MAIN HEIGHT', mainContentHeight, "HEADER HEIGHT", mainContentHeaderHeight);
  } */

}
